import { render, staticRenderFns } from "./GalleryActions.vue?vue&type=template&id=639b3c2e&scoped=true"
import script from "./GalleryActions.vue?vue&type=script&lang=js"
export * from "./GalleryActions.vue?vue&type=script&lang=js"
import style0 from "./GalleryActions.vue?vue&type=style&index=0&id=639b3c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b3c2e",
  null
  
)

export default component.exports